import Vue from 'vue'

export default (component) => {
  const instance = new Vue(component)
  document.body.appendChild(instance.$mount().$el)
  return instance
}